export default "__VITE_ASSET__ClrbYGE3__"